<template>
  <v-card class="mt-4">
    <div class="p-4 border-bottom">
      <h5 class="text-black-90 titulo_nitro">
        Calendário
      </h5>
      <h6
        class="titulo_nitro text-gray-400"
      >
        Novidades da semana
      </h6>
    </div>
    <events-calendar
      period="week"
    />
  </v-card>
</template>
<script>
import EventsCalendar from '../../../components/calendar/EventsCalendar.vue';

export default {
  components: {
    EventsCalendar
  }
}
</script>
